// extracted by mini-css-extract-plugin
export default {"logo":"index_logo__RHSeM"};